import React, {useState} from 'react';

// UI
import {Dialog, DialogContent, DialogTitle,makeStyles, TextField} from '@material-ui/core';
import {Feedback, ErrorOutline} from "@material-ui/icons";
import Grid from "@material-ui/core/Grid";
import Button from "@material-ui/core/Button";
import Autocomplete from "@material-ui/lab/Autocomplete";
import _ from "lodash";
import CenteredLoader from "../../../components/Loading/CenteredLoader";
import ApiService from "../../../services/ApiService";

const useStyles = makeStyles(() => ({
  button: {
    marginTop: 10,
    marginBottom: 10
  },
  formField: {
    marginTop: 20
  }
}))



export default function OpenTicketDialog({open, toggleOpen, openAlert, triplets, ticketSpecificFaq}) {
  const classes = useStyles();
  const [loading, setLoading] = useState(false);
  const [verticalSelected, setVerticalSelected] = useState();
  const [macrotemaSelected, setMacrotemaSelected] = useState();
  const [referente, setReferente] = useState();
  const [description, setDescription] = useState();

  function onVerticalChange(event, vertical) {
    setVerticalSelected(vertical)
    setMacrotemaSelected(undefined)
  }

  function onMacrotemaChange(event, macrotema) {
    setMacrotemaSelected(macrotema)
    if (!macrotema || macrotema === 'Nessun macrotema specifico') {
      setReferente(undefined)
    } else {
      setReferente(_.find(triplets, (i) => i.macrotema === macrotema)['id_referente'])
    }
  }

  const _onSubmit = () => {
    setLoading(true)
    const data = {
      id_domanda: ticketSpecificFaq ? ticketSpecificFaq._id : undefined,
      domanda: ticketSpecificFaq ? ticketSpecificFaq._source.domanda : undefined,
      html_risposta: ticketSpecificFaq ? ticketSpecificFaq._source.html_risposta : undefined,
      vertical: ticketSpecificFaq ? ticketSpecificFaq._source.vertical : verticalSelected,
      macrotema: ticketSpecificFaq ? ticketSpecificFaq._source.macrotema :
        macrotemaSelected !== 'Nessun macrotema specifico' ? macrotemaSelected : undefined,
      tema: ticketSpecificFaq ? ticketSpecificFaq._source.tema : undefined,
      segnalazione: description,
      id_referente: ticketSpecificFaq ? _.find(triplets, (i) => i.macrotema === ticketSpecificFaq._source.macrotema)['id_referente'] : referente
    }
    console.log(data)
    ApiService.postApi('ticket', data)
      .then((msg) => {
        console.log(msg)
        openAlert("success", "Segnalazione inviata con successo");
        toggleOpen()
      })
      .catch((err) => {
        console.log(err)
        openAlert("error", "Errore imprevisto durante l'invio");
      })
      .finally(() => {setLoading(false)})
  }

  return (
    <div key='addFaqDialog'>
      <Dialog
        open={open}
        onClose={toggleOpen}
        disableEnforceFocus={true}
        fullWidth
        maxWidth="md">
        <DialogTitle id="form-dialog-title">
          <Feedback color="primary" style={{marginRight: 10}}/>Apertura segnalazione
        </DialogTitle>
        {ticketSpecificFaq &&
          <DialogContent>
            <p><b>Oggetto della segnalazione:</b></p>
            <Grid container spacing={3}>
              {['vertical', 'macrotema', 'tema'].map(i => (
                <Grid item style={{marginLeft: "auto", marginRight: "auto"}} key={i}>
                  <b>{i.toUpperCase()}: </b> {ticketSpecificFaq._source[i]}
                </Grid>
              ))}
              <Grid item xs={12}>
                <b>DOMANDA: </b> <i>{ticketSpecificFaq._source.domanda}</i>
              </Grid>
            </Grid>
          </DialogContent>
        }
        {!ticketSpecificFaq &&
          <DialogContent>
            <p><b>Specifica l'ambito della tua segnalazione affinchè venga indirizzata al destinatario corretto</b></p>
            <Autocomplete
              id="box-vertical"
              options={[...new Set(triplets.map(item => item.vertical).filter(i => i !== ''))]}
              onChange={onVerticalChange}
              value={verticalSelected || null}
              className={classes.formField}
              renderInput={(params) => (
                <TextField {...params} label="Seleziona vertical" variant="outlined"/>
              )}
            />
            <Autocomplete
                id="box-macrotema"
                options={[...new Set(triplets.filter(obj => obj.vertical === verticalSelected).map(item => item.macrotema))].concat(['Nessun macrotema specifico'])}
                onChange={onMacrotemaChange}
                value={macrotemaSelected || null}
                className={classes.formField}
                renderInput={(params) => (
                  <TextField {...params} label="Seleziona macrotema" variant="outlined"/>
                )}
                disabled={!verticalSelected}
              />
          </DialogContent>
        }
        <DialogContent>
          <TextField
            id="description"
            onChange={(e) => setDescription(e.target.value)}
            value={description}
            multiline
            margin="dense"
            label="Testo della segnalazione"
            variant="outlined"
            fullWidth
            inputProps={{style: {height: 100}}}
            disabled={!ticketSpecificFaq && !macrotemaSelected}
          />
          <p style={{marginTop: 15, marginBottom: 15}}>
            <ErrorOutline style={{ marginRight: 10 }} color="primary" />
            Inviando la segnalazione riceverai via mail una notifica con la risposta del team di supporto.
          </p>
          <Grid container>
            <Grid item xs={5}>
              <Button onClick={toggleOpen} variant="contained" className={classes.button}>
                Esci
              </Button>
            </Grid>
            <Grid item xs={2}>
              {loading && <CenteredLoader />}
            </Grid>
            <Grid item xs={5} style={{textAlign: "end"}}>
              <Button
                form="add-user-form"
                onClick={_onSubmit}
                color="primary"
                variant="contained"
                disabled={!description}
                className={classes.button}
              >
                Invia
              </Button>
            </Grid>
          </Grid>
        </DialogContent>
      </Dialog>
    </div>
  );
}
